<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import ListagemGenerica from '@/components(new)/UI/Tables/ListagemGenerica/ListagemGenerica.vue'
import FiltroGenerico from '@/components(new)/UI/Filters/FiltroGenerico/FiltroGenerico.vue'
import BaseTable from '@/components(new)/UI/Tables/BaseTable/BaseTable.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import EMPTY_FILTRO_VISTORIA from '@/libs/models/filtro/emptyFiltroVistoria'
import statusVistoria from '@/libs/constants/vistoria/status'
import PermissaoHelper from '@/utils/PermissaoHelper.vue'
import AppModalVisualizarCadastro from '@/components(new)/UI/Modals/VisualizacaoCadastro/AppModalVisualizarCadastro.vue'
import TrocarResponsavel from '@/components(new)/UI/Modals/TrocarResponsavel/TrocarResponsavel.vue'
import VisualizarDocumentos from '@/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue'

export default {
  mixins: [
    AppNotificacao,
    PermissaoHelper
  ],
  components: {
    ListagemGenerica,
    FiltroGenerico,
    BaseTable,
    InputSelect,
    AppModalVisualizarCadastro,
    TrocarResponsavel,
    VisualizarDocumentos
  },
  data () {
    return {
      filtro: EMPTY_FILTRO_VISTORIA('CAIXA_ENTRADA'),
      totalElements: 0,
      totalPages: 0,
      vistorias: [],
      municipios: [],
      status: [],
      orgaos: [],
      responsaveis: [],
      usuario: null,
      modalVisualizarCadastroIsOpen: false,
      protocolo: null,
      modalTrocarResponsavelIsOpen: false,
      idVistoria: null,
      modalVisualizarDocumentoIsOpen: false,
      documentos: [],
      tituloVisualizarDocumento: null
    }
  },
  async created () {
    this.usuario = await this.getUsuario()
  },
  mounted () {
    this.loadLista()
    this.getMunicipios()
    this.getStatus()
    this.getOrgaos()
    this.getResponsaveis()
  },
  methods: {
    ...mapActions({
      findStatusByCaixa: 'status/findByCaixa',
      findByFilter: 'vistoria/findByFilter',
      findAllOrgaos: 'pessoa/findAllOrgaos',
      findMunicipioByCadastros: 'municipios/findMunicipioByCadastros',
      findResponsaveisBySetorLogado: 'usuario/findResponsaveisBySetorLogado',
      trocarResponsavel: 'vistoria/trocarResponsavel',
      getUsuario: 'auth/getUsuario',
      getLaudosMonitoramentoAmbientalByIdProcesso: 'monitoramentoAmbiental/getLaudosByIdProcesso',
      regerarLaudoMonitoramentoAmbientalByIdProcesso: 'monitoramentoAmbiental/regerarByIdProcesso'
    }),
    async loadLista () {
      const response = await this.findByFilter(this.filtro)
      this.vistorias = this.formatarDadosTabela(response.content)
      this.totalElements = response.totalElements
      this.totalPages = response.totalPages
    },
    formatarDadosTabela (dados) {
      return dados.map(dado => ({
        ...dado,
        actions: [
          { key: 'view-process', label: 'Visualizar processo', iconPrefix: 'far', icon: 'eye', action: () => this.viewCadastro(dado.numeroProtocolo) },
          { key: 'view-report', label: 'Visualizar laudo de analise preliminar', iconPrefix: 'fal', icon: 'clipboard-list', action: () => this.visualizarLaudoAnalisePreliminar(dado.idProcesso), show: dado.hasLaudoPreliminar },
          { key: 'generate-report', label: 'Gerar nova análise preliminar', iconPrefix: 'fal', icon: 'sync', action: () => this.regerarAnalisePreliminar(dado.idProcesso), show: dado.status.codigo === statusVistoria.AGUARDANDO },
          { key: 'change-responsible', label: (!dado.nomeResponsavel ? 'Vincular processo' : 'Trocar responsável'), iconPrefix: 'fal', icon: 'users', action: () => this.openModalTrocarResponsavel(dado.id), show: this.isChefeSetor() },
          { key: 'link-process', label: 'Vincular processo', iconPrefix: 'fal', icon: 'file-import', action: () => this.alterarResponsavel(dado.id, this.usuario.id), show: (!this.isChefeSetor() && !dado.nomeResponsavel) }
        ]
      }))
    },
    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.loadLista()
    },
    pesquisar (pesquisaSimples) {
      this.filtro.campoSimples = pesquisaSimples
      this.filtro.pagina = 0
      this.loadLista()
    },
    limparPesquisa () {
      this.filtro = EMPTY_FILTRO_VISTORIA('CAIXA_ENTRADA')
      this.loadLista()
    },
    async getMunicipios () {
      const municipios = await this.findMunicipioByCadastros()
      this.municipios = municipios.map(municipio => ({id: municipio.id, nome: municipio.nome}))
    },
    async getStatus () {
      const status = await this.findStatusByCaixa('CAIXA_ENTRADA')
      this.status = status.map(status => ({id: status.codigo, nome: status.nome}))
    },
    async getOrgaos () {
      const orgaos = await this.findAllOrgaos()
      this.orgaos = orgaos.map(orgao => ({id: orgao, nome: orgao}))
    },
    async getResponsaveis () {
      const responsaveis = await this.findResponsaveisBySetorLogado()
      this.responsaveis = responsaveis.map(responsavel => ({id: responsavel.id, nome: `${responsavel.nomeRazaoSocial} (${responsavel.perfil.nome})`}))
    },
    async alterarResponsavel (idVistoria, idUsuario) {
      await this.trocarResponsavel({idVistoria, idUsuario})
      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Vistoriador alterado com sucesso.')
      this.limparPesquisa()
    },
    viewCadastro (protocolo) {
      this.protocolo = protocolo
      this.modalVisualizarCadastroIsOpen = true
    },
    closeModalVisualizarCadastro () {
      this.modalVisualizarCadastroIsOpen = false
      this.protocolo = null
    },
    openModalTrocarResponsavel (idVistoria) {
      this.modalTrocarResponsavelIsOpen = true
      this.idVistoria = idVistoria
    },
    closeModalTrocarResponsavel () {
      this.modalTrocarResponsavelIsOpen = false
      this.idVistoria = null
    },
    async handleAlterarResponsavelModal (idResponsavel) {
      await this.alterarResponsavel(this.idVistoria, idResponsavel)
      this.closeModalTrocarResponsavel()
    },
    async visualizarLaudoAnalisePreliminar (idProcesso) {
      this.tituloVisualizarDocumento = 'Laudo de Análise Preliminar'
      this.documentos = await this.getLaudosMonitoramentoAmbientalByIdProcesso(idProcesso)
      this.openModalVisualizarDocumento()
    },
    async openModalVisualizarDocumento () {
      if (!this.documentos?.length) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Documento não encontrado.')
        return
      }
      this.modalVisualizarDocumentoIsOpen = true
    },
    closeModalVisualizarDocumento () {
      this.modalVisualizarDocumentoIsOpen = false
      this.documentos = []
      this.tituloVisualizarDocumento = null
    },
    async regerarAnalisePreliminar (idProcesso) {
      await this.regerarLaudoMonitoramentoAmbientalByIdProcesso(idProcesso)
      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'O Laudo de Análise Preliminar será regerado em breve.')
    }
  }
}
</script>

<template>
  <div class="container">
    <AppModalVisualizarCadastro
      v-if="modalVisualizarCadastroIsOpen"
      :protocolo="protocolo"
      @closeModal="closeModalVisualizarCadastro"
    />
    <TrocarResponsavel
      v-if="modalTrocarResponsavelIsOpen"
      @closeModal="closeModalTrocarResponsavel"
      @alterar="handleAlterarResponsavelModal"
    />
    <VisualizarDocumentos
      v-if="modalVisualizarDocumentoIsOpen"
      @closeModal="closeModalVisualizarDocumento"
      :titulo="tituloVisualizarDocumento"
      :documentos="documentos"
    />
    <div class="content-cadastro">
      <div class="flex-start mt-3 mb-3">
        <FiltroGenerico
          placeholder="Pesquisar por número de processo, nome do proprietário ou CPF/CNPJ"
          widthInput="85%"
          @filtrosPesquisa="pesquisar"
          @limpar="limparPesquisa"
        >
          <template #filtros>
            <InputSelect
              label="Municípios:" v-model="filtro.municipios"
              :multiSelect="true"
              :opcoes="municipios"
            />
            <InputSelect
              label="Status:" v-model="filtro.status"
              :opcoes="status"
            />
            <InputSelect
              label="Órgão:" v-model="filtro.orgao"
              :opcoes="orgaos"
            />
            <InputSelect
              label="Responsável:" v-model="filtro.responsavel"
              :opcoes="responsaveis"
            />
          </template>
        </FiltroGenerico>
      </div>
      <BaseTable
        title="Listagem"
        :tableData="vistorias"
        emptyText="Não foram encontradas vistorias."
        :columns="[
          { key: 'numeroProcesso', label: 'N° Processo', width: '150rem' },
          { key: 'cpfCnpjProprietario', label: 'CPF/CNPJ', width: '150rem'},
          { key: 'nomeRazaoSocialProprietario', label: 'Proprietário/Razão social' },
          { key: 'status.nome', label: 'Status', align: 'center' },
          { key: 'municipio', label: 'Município' },
          { key: 'nomeResponsavel', label: 'Responsável' },
          { key: 'orgao', label: 'Órgão' },
          { key: 'actions', label: 'Ações', align: 'center' }
        ]"
        :pagination="{
          show: true,
          pageSize: filtro.tamanhoPagina,
          totalPages: totalPages,
          totalElements: totalElements
        }"
        @pageChange="changePage"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/analise/vistoria/caixa-entrada/caixa-entrada.vue